export default "__VITE_ASSET__Btw6RI7b__"